import http from '@/utils/http';
const base_path = '/v2/tool/businessCategory';

/**
 * 获取创意分类列表接口
 * @param {Object} params 查询参数
 * @returns {Promise<Object>}
 */
export const getBusinessCategoryListApi = (params) => {
  return http.get({
    url: base_path,
    params,
  });
};
